export default "__VITE_ASSET__5qY_fPBt__"